import { render, staticRenderFns } from "./ShowView.vue?vue&type=template&id=36e1c63e"
import script from "./ShowView.vue?vue&type=script&lang=js"
export * from "./ShowView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports